import { Grid } from "antd-mobile";
import { useTranslation } from "react-i18next";
import { moneyFormat } from "../../plugins/numberFormat";
import { useGetAgentBalance } from "../Personal/hooks/personal.hook";
import styles from "./style.module.scss";

const Balance = () => {
  const { t } = useTranslation();
  const { data: agentBalance } = useGetAgentBalance({
    params: {
      all: true,
    },
  });
  return (
    <div className={styles.container}>
      <Grid columns={2} gap={8}>
        {!agentBalance
          ? null
          : agentBalance.map((balance) => {
              return (
                <Grid.Item key={balance.id}>
                  <div className={styles.itemContainer}>
                    <div className={styles.currency}>{balance.currency}</div>
                    <div className={styles.money}>{`${t(
                      `global.currency.${balance.currency.toUpperCase()}`,
                    )}${moneyFormat(balance.money)}`}</div>
                  </div>
                </Grid.Item>
              );
            })}
      </Grid>
    </div>
  );
};

export default Balance;
